export const FLAG_GETTING_CARGO_ITEMS = 'FLAG_GETTING_CARGO_ITEMS';
export const GET_CARGO_ITEMS = 'GET_CARGO_ITEMS';
export const CLEAR_CARGO_ITEMS = 'CLEAR_CARGO_ITEMS';
export const FLAG_CARGO_ITEM_ACTIVITY = 'FLAG_CARGO_ITEM_ACTIVITY';
export const GET_CARGO_ITEM = 'GET_CARGO_ITEM';
export const CLEAR_CARGO_ITEM = 'CLEAR_CARGO_ITEM';
export const GET_CARGO_ITEM_DETAIL = 'GET_CARGO_ITEM_DETAIL';
export const CLEAR_CARGO_ITEM_DETAIL = 'GET_CARGO_ITEM_DETAIL';
